import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

// get auth state slice from the full state
const useIncludeReturnsWithNoAssets = () => useSelector((state: RootState) => state?.returns?.includeReturnsWithNoAssets || false);

export default useIncludeReturnsWithNoAssets;